import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from "react";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";
import axios from "axios";
import swal from "sweetalert";
import config from "../../config.js";
import Cookies from "universal-cookie";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import mixpanel from "mixpanel-browser";

const cookies = new Cookies();
const userToken = cookies.get("userToken");
const headers = {
  Authorization: `Bearer ${userToken}`,
  "Content-Type": "application/json",
};

let selectedData = [];
let table;

const Delete = async (e) => {
  mixpanel.track("User Page Delete Button Clicked", {
    userID: cookies.get("userID"),
  });
  const actionInitiatingUser = parseInt(cookies.get("userID"));
  if (selectedData.length === 0) {
    swal("No User Selected", "Process Failed", "error");
  } else {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover these users!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .post(
            config.BACKEND_URL + "/users/delete-users",
            {
              IDs: selectedData,
              actionInitiatingUser,
            },
            { headers }
          )
          .then((res) => {
            swal("Users Deleted", "Process Successful", "success").then(() => {
              window.location.reload();
            });
          })
          .catch((err) => {
            swal("Users Not Deleted!", "Process Failed", "error");
            console.log(err);
          });
      } else {
        swal("Users Not Deleted!", "Action cancelled.", "info");
      }
    });
  }
};

async function fetchData() {
  let Users = [];
  axios
    .get(config.BACKEND_URL + "/users", { headers })
    .then((res) => {
      Users = res.data.data;
      table.setData(Users);
    })
    .catch((err) => {
      console.log(err);
    });
}

function UserTable({
  setUserToEdit,
  edit,
  deletee,
  setSelectedUser = { setSelectedUser },
}) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogContent, setDialogContent] = React.useState("");

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleClick = async (e, cell, data) => {
    setDialogOpen(true);
    await axios
      .post(
        config.BACKEND_URL + "/users/get-role-by-id",
        { id: data.id },
        { headers }
      )
      .then((res) => {
        data = { ...data, role: res.data.role, fullname: res.data.fullname };
      })
      .catch((err) => {
        console.log(err);
      });
    const message = `Name: ${data.fullname}\nEmail: ${data.email}\nContact: ${
      data.contact
    }\nRole: ${!data.role ? "NA" : data.role}`;
    setDialogContent(message);
  };

  const buttonFormatter = () => {
    return "<Button variant='outlined' color='primary'>Details</Button>";
  };

  const columns = [
    { formatter: "rownum", align: "center" },
    { title: "Username", field: "name", headerFilter: "input", width: "40%" },
    {
      title: "Information",
      width: "40%",
      formatter: buttonFormatter,
      cellClick: function (e, cell) {
        e.stopPropagation();
        if (cell.getColumn()._column.definition.title === "Information") {
          cell.getRow().getElement().classList.remove("tabulator-selected");
        }
        handleClick(e, cell, cell.getRow().getData());
        table.deselectRow();
      },
    },
  ];

  useEffect(() => {
    table = new Tabulator("#user-table", {
      rowClick: function (e, row) {
        alert("Row " + row.getData().name + " Clicked!!!!");
      },
      layout: "fitColumns",
      columns: columns,
      pagination: "local",
      paginationSize: 10,
      paginationSizeSelector: [25, 50, 75, 100],
      tooltips: true,
      responsiveLayout: true,
      selectableRows: true,
    });

    table.on("tableBuilt", fetchData);
    table.on("rowSelectionChanged", () => {
      selectedData = table.getSelectedData().map((user) => user.id);
      setSelectedUser(selectedData);
    });
  }, []);

  const Edit = (e) => {
    mixpanel.track("User Page Edit Button Clicked", {
      userID: cookies.get("userID"),
    });
    const selectedRows = table.getSelectedData();
    if (selectedRows.length !== 1) {
      swal("Cannot edit row", "Please select only one row to edit", "error");
      return;
    } else {
      const userData = selectedRows[0]; // Get full user data from the table
      setUserToEdit(userData); // Set the user to edit in the parent state
    }
  };

  return (
    <>
      <div className="UserTable">
        <div style={{ padding: "25px" }}>
          <div id="user-table"></div>
        </div>
      </div>
      <div>
        {deletee && (
          <button
            className="btn btn-danger mx-4"
            type="button"
            onClick={Delete}
          >
            Delete
          </button>
        )}
        {edit && (
          <button className="btn btn-primary" type="button" onClick={Edit}>
            Edit
          </button>
        )}
      </div>
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        disableScrollLock
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: 600,
            bgcolor: "#0f172a",
            color: "white",
          }}
        >
          Information
          <IconButton onClick={handleClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Divider />

        {/* Content */}
        <DialogContent sx={{ bgcolor: "#f8fafc", py: 3 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {dialogContent.split("\n").map((line, i) => {
              const [key, value] = line.split(":");
              return (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    gap: 1,
                    fontSize: "0.95rem",
                    bgcolor: "white",
                    p: 1.5,
                    borderRadius: 1.5,
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <Typography sx={{ fontWeight: 600, minWidth: 120 }}>
                    {key}:
                  </Typography>
                  <Typography sx={{ color: "#475569" }}>
                    {value || "-"}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default UserTable;
